// extracted by mini-css-extract-plugin
module.exports = {"content__title":"content_content__title__nETUh","content__card":"content_content__card__QHd5a","slide":"content_slide__DhNW1"};